import React, { useState, useEffect, useContext } from 'react';
import JobAssetService from "../../Controller/JobAssetController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

import { useNavigate, Link, useLocation } from 'react-router-dom';
import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import handleSubmitForCheckbox from "../../Controller/CreateJobAssetController";
import JobService from "../../Controller/JobController";
import HelpSite from "../../../Common/HelpLink";
import JobAssetsPage from "./JobAssets";
import AssetDetailModal from "../../../Asset/View/AssetDetail";
function AssetJobListPage(JobID) {
    JobID = localStorage.getItem('JobID');
    const navigate = useNavigate();
    const [formList, setForms] = useState([]);
    const { t, i18n } = useTranslation();
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [checkboxState, setCheckboxState] = useState({});
    const [isClosed, SetIsClosed] = useState("0");
    const [isAssetID, SetIsAssetID] = useState(0);
    const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
    const handleCheckboxChange = (event) => {

        const { name, checked } = event.target;
        setCheckboxState({ ...checkboxState, [name]: checked });
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleSubmitForm = async () => {

        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/JobsList?saved=true');
        };

        try {
            debugger;
            const checkedAssetIDs = Object.keys(checkboxState).filter(id => checkboxState[id]);
            const UserID = localStorage.getItem("UserID");
            const payload = {
                JobID: JobID,
                UserID: UserID,
                checkedAssets: checkedAssetIDs, // Only true ones sent
            };
            const message = await handleSubmitForCheckbox(payload, redirectCallback);
            if (message == "Data saved successfully") {
                let JobCostID = localStorage.getItem('JobCostID');
                JobCostID = JobCostID + 1;
                localStorage.setItem('JobCostID', JobCostID);
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
        } catch (error) {
            console.error('Error handling form submission:', error);
            // Handle error (e.g., display an error message)
        }
    };
    const fetchJobDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                SetIsClosed(jobDetail[0].IsCompleted);

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };

    useEffect(() => {
        SetIsClosed(localStorage.getItem("Closed"));

        async function fetchData() {
            try {
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };
                const formData = await JobAssetService.GetAllJobAssets(redirectCallback, JobID); // Pass the language parameter
                setForms(formData);
                const initialState = {};
                formData.forEach(form => {
                    initialState[form.PK_Assets_ID] = form.FK_Asset_ID !== null;
                });
                setCheckboxState(initialState);
            } catch (error) {
                console.error('Error fetching Users:', error);
            }
        }
        fetchData();
    }, [JobID, localStorage.getItem("Closed")]); // Listen to changes in language
    const truncateText = (text, maxLength = 50) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleEditClick = async (AssetID) => {
        try {
            SetIsAssetID(AssetID);
            setIsModalOpen(true);

        }
        catch (error) {
            alert(error);
        }
    };
    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                        <thead>
                            <tr>
                                <th style={{ "width": "10%" }}></th>
                                <th>Asset Name</th>
                                <th>Serial No.</th>
                                <th>Ownership</th>
                            </tr>
                        </thead>
                    </table>
                    <div style={{ maxHeight: "460px", overflow: "auto" }}>
                        <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                            <tbody>
                                {formList.map(form => (
                                    <tr key={form.PK_Assets_ID} onClick={() => handleEditClick(form.PK_Assets_ID)}>
                                        <td style={{ "width": "10%" }}>
                                            <input
                                                type="checkbox"
                                                name={form.PK_Assets_ID}
                                                checked={checkboxState[form.PK_Assets_ID] || false}
                                                onChange={handleCheckboxChange}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                        </td>
                                        <td className="no-wrap">{truncateText(form.vc_AssetName)}</td>
                                        <td className="no-wrap">{truncateText(form.vc_SerialNumber)}</td>
                                        <td className="no-wrap">{truncateText(form.CompanyNames)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


            <div className="row" style={{ "marginLeft": "0px", "float": "right" }}>
                <div className="col-sm-12">
                    <button type="button" onClick={handleSubmitForm} className="btn btn-primary" disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                       <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />  Save
                    </button>

                </div>
            </div>
            {isModalOpen && (
                <AssetDetailModal AssetID={isAssetID} onClose={handleCloseModal}  ClientCompanyID={"0"} />
               
            )}
        </div>

    );
}

export default AssetJobListPage;